export default "__VITE_ASSET__D3GLP0cK__"